// extracted by mini-css-extract-plugin
export default {"gradient":"introAGradient_gradient__2r7FR"};